<script>
    import { createEventDispatcher } from 'svelte';
    import { badgesFor } from './tarotBadges.js';
    import BadgeRow from './BadgeRow.svelte';
    import GameText from './GameText.svelte';

    export let entry;
    export let view = 'grid';
    export let groupedBy = null;
    export let searching = false;

    const dispatch = createEventDispatcher();

    $: role = entry;
    $: badges = badgesFor(role);

    // cardSummary drops the "You are a <Role>." opener that every engine snippet
    // carries. Falls back to the raw snippet for any payload built before that field.
    $: summary = role.cardSummary || role.snippet;

    // Cards view is a name-and-signal grid with no prose, so 137 roles stay scannable.
    // The summary is still reachable: on hover as a tooltip, and rendered in List view.
    // While a search is running it is shown regardless: searchText indexes the summary,
    // so a result matched on words the card would otherwise never display.
    $: showSummary = (view === 'list' || searching) && summary;

    // The section heading already names the faction when grouped by it, and the card's
    // colour bar carries it visually, so the pill is redundant there.
    $: showFactionPill = groupedBy !== 'faction';

    function selectTag(tag) {
        dispatch('selectFacet', { id: 'tag', value: tag });
    }

    function selectFaction() {
        dispatch('selectFacet', { id: 'faction', value: role.factionSlug });
    }
</script>

<div
    class="guide-card faction-{role.factionSlug}"
    class:guide-card--compact={view !== 'list'}>
    <span class="guide-card-bar" aria-hidden="true"></span>
    <div class="guide-card-body">
        <div class="guide-card-head">
            <a
                class="guide-card-name guide-card-link"
                href={`/guides/roles/${role.slug}`}
                title={summary}>{role.displayName}</a>
            {#each role.categories || [] as category}
                <button
                    type="button"
                    class="guide-category-pill guide-category-pill--{category.toLowerCase()}"
                    on:click={() => dispatch('selectFacet', { id: 'category', value: category })}>
                    {category}
                </button>
            {/each}
            {#if showFactionPill}
                <button
                    type="button"
                    class="guide-accent-pill guide-accent-pill--button faction-{role.factionSlug}"
                    on:click={selectFaction}>
                    {role.faction}
                </button>
            {/if}
        </div>

        {#if showSummary}
            <span class="guide-card-snippet">{summary}</span>
        {/if}

        <BadgeRow {badges} {view} />


        {#if role.tags && role.tags.length > 0}
            <span class="guide-card-tags">
                {#each role.tags as tag}
                    <button type="button" class="guide-tag-pill" on:click={() => selectTag(tag)}>
                        <GameText text={tag} />
                    </button>
                {/each}
            </span>
        {/if}
    </div>
</div>
